module.exports = __webpack_public_path__ + "static/media/15_Bild_3_Sofa_EXO_Team_PolyWalk-EPFL_NicolaPitaro_6941.1535a434.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle15/15_Bild_3_Sofa_EXO_Team_PolyWalk-EPFL_NicolaPitaro_6941.jpg
 ** module id = 156
 ** module chunks = 0
 **/